export enum FeeCalculationType {
  FixedAmount = 'FIXED',
  Percentage = 'PERCENTAGE',
}
